import { gql } from '@apollo/client';

const CREATE_VIEW_TAB_EVENT = gql`
  mutation createViewTabEvent($data: ViewTabEventCreateInput!) {
    createViewTabEvent(data: $data)
  }
`;

export default CREATE_VIEW_TAB_EVENT;
